import React, { Component } from "react";
import Fade from "react-reveal/Fade";

import SectionTitle from "../SectionTitle/SectionTitle";
import Development from "../../assets/img/goals/development.svg";
import Location from "../../assets/img/goals/location.svg";
import Support from "../../assets/img/goals/support.svg";
import Book from "../../assets/img/goals/book.svg";
import Develop from "../../assets/img/goals/develop.svg";

import "./Goals.css";
const goals = [
  {
    img: Development,
    content: "رفع كفاءة الجهات الحكومية"
  },
  {
    img: Location,
    content: "الاستفادة من التجارب الدولية وتطبيقها على المؤسسات الحكومية"
  },
  {
    img: Support,
    content: "تمكين وتحفيز الجهات الحكومية لدعم التحول الرقمي"
  },
  {
    img: Book,
    content: "نشر المعرفة في مجال التحول الرقمي الحكومي"
  },
  {
    img: Develop,
    content: "الاستفادة من الخبرات الوطنية وتفعيل التواصل بين القيادات"
  }
];

export default class Goals extends Component {
  render() {
    return (
      <section id="goals" className="section mt-2">
        <Fade duration={1000} delay={200}>
          <SectionTitle>أهداف الأكاديمية </SectionTitle>
        </Fade>
        <div className="columns has-text-centered mt-5 pad-2">
          {goals.map((goal, i) => {
            return (
              <Fade duration={1000} delay={200} key={i}>
                <div className="column mt-2">
                  <div className="tile is-parent">
                    <div className="tile is-child">
                      <img src={goal.img} alt={goal.content} />
                      <p className="subtitle mt-2">{goal.content}</p>
                    </div>
                  </div>
                </div>
              </Fade>
            );
          })}
        </div>
      </section>
    );
  }
}
